module.exports = __webpack_public_path__ + "img/treatment-based-options-mobile-en.a2745a50.jpg";